<template>
    <div class="card">
        <header class="card-header">
            <div class="card-header-title">
                INLAND PRICE CALCULATOR
            </div>
            <div class="card-header-icon" aria-label="more options">
              <span class="icon has-text-danger">
                <i class="fas fa-yen" aria-hidden="true"></i>
              </span>
            </div>
        </header>
        <div class="card-content">
            <div class="field">
                <p class="control is-expanded has-icons-left is-fullwidth">
                    <input v-model="price" class="input" type="number" placeholder="Result" disabled>
                    <span class="icon is-small is-left">
                        <i class="fas fa-yen-sign"></i>
                    </span>
                </p>
            </div>
            <div class="field">
                <div class="select is-fullwidth">
                    <select v-model="query.auction" @change="getClosestPort(query.auction)">
                        <option :value="null" disabled hidden>Select Auction House</option>
                        <option v-for="auction in auctions"
                                :value="auction">
                            {{ auction }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="field">
                <div class="select is-fullwidth">
                    <select v-model="query.port">
                        <option :value="null" disabled hidden>Select Port</option>
                        <option v-for="port in ports"
                                :value="port">
                            {{ port }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="field">
                <p class="control is-expanded has-icons-left is-fullwidth">
                    <input v-model="query.lot_number" class="input" type="number" placeholder="Type lot number">
                    <span class="icon is-small is-left">
                        <i class="fas fa-gavel"></i>
                    </span>
                </p>
            </div>
            <div class="field">
                <button class="button is-fullwidth is-primary" @click="calculatePrice">Calculate</button>
            </div>
        </div>
    </div>
</template>

<script>
    import apiInlandPrice from './../../../api/apiInlandPrice'
    import moment from 'moment'
    export default {
        props: ['lot'],
        data () {
            return {
                query: {
                    auction: null,
                    port: null,
                    lot_number: null
                },
                auctions: null,
                ports: null,
                price: null,
                isLoading: false
            }
        },
        methods: {
            calculatePrice() {
                apiInlandPrice
                    .requestPrice(this.query)
                    .then((response) => {
                        this.price = response.data[0]
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            },
            getClosestPort(auction){
                apiInlandPrice
                    .requestClosestPort({auction: auction})
                    .then((response) => {
                        this.query.port = response.data[0]
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            }
        },
        created() {
            apiInlandPrice
                .requestAuctionsList()
                .then((response) => {
                    this.auctions = response.data
                })
                .catch((error) => {
                    console.log(error)
                })
            apiInlandPrice
                .requestPortsList()
                .then((response) => {
                    this.ports = response.data
                })
                .catch((error) => {
                    console.log(error)
                })
            if (this.lot) {
                this.query.auction = this.lot.auction_name
            }
        }
    }
</script>

<style scoped>
    .card {
        height: 320px;
    }
    th {
        font-size: small;
    }
    td {
        font-size: small;
    }
</style>



// WEBPACK FOOTER //
// src/components/Tools/Calculators/InlandCalculator.vue